module.exports = "/images/Seguridad.svg";